'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('@ali/prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _log = require('@ali/log');

var _log2 = _interopRequireDefault(_log);

var _broccoliChangeLange = require('@ali/broccoli-change-lange');

var _broccoliChangeLange2 = _interopRequireDefault(_broccoliChangeLange);

require('./index.styl');

var _network = require('@ali/network');

var _network2 = _interopRequireDefault(_network);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('@ali/bucket/components/share'),
    _require$SHARE_TYPE = _require.SHARE_TYPE,
    FB = _require$SHARE_TYPE.FB,
    WHATSAPP = _require$SHARE_TYPE.WHATSAPP,
    CLIENT = _require$SHARE_TYPE.CLIENT,
    share = _require.share;

// if (module.hot) {
//   // 开发插入本地语言包
//   window.__intl__ = Object.assign({}, window.__BROCCOLI_EXT_CONFIG__.__intl__);
// }

var Index = function (_Component) {
  _inherits(Index, _Component);

  function Index() {
    _classCallCheck(this, Index);

    return _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).apply(this, arguments));
  }

  _createClass(Index, [{
    key: 'checkModal',
    value: function checkModal() {
      var param = _network2.default.query('uc_biz_str') || '';
      if (param !== '') {
        return true;
      }
      return false;
    }
  }, {
    key: '_actShare',
    value: function _actShare() {
      var _props = this.props,
          shareScene = _props.shareScene,
          pg = _props.pg,
          query = _props.query;

      var redirectParam = this.checkModal() ? {
        uc_biz_str: 'action:base.openwindow%7Cparam:S.object=infoflow;S.scene=1002;l.channel=-1;end'
      } : {};
      var shareConfig = {
        scene: shareScene,
        shareBackupList: [CLIENT, FB, WHATSAPP],
        logParams: {
          ckId: 'share_btn_' + pg,
          pg: pg
        },
        query: _extends({
          redirect: redirectParam
        }, query),
        isShortLink: this.props.isShortLink || true
      };
      share(shareConfig);
    }
  }, {
    key: '_actRule',
    value: function _actRule() {
      var _this2 = this;

      var pg = this.props.pg;

      _log2.default.logClick('act_rule_' + pg, { pg: pg });
      setTimeout(function () {
        var linkRule = _this2.props.linkRule;

        if (_network2.default.query('lange')) {
          linkRule = '' + linkRule + (linkRule.indexOf('?') <= -1 ? '?' : '&') + 'lange=' + _network2.default.query('lange');
        }
        window.location.href = linkRule;
      }, 200);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          langeConf = _props2.langeConf,
          cls = _props2.cls,
          shareBtnStyle = _props2.shareBtnStyle,
          ruleBtnStyle = _props2.ruleBtnStyle;

      return _react2.default.createElement(
        'div',
        { className: 'broccoli-cmp-header ' + (cls ? cls : '') },
        _react2.default.createElement('div', {
          className: 'broccoli-cmp-actend-sharbtn',
          onClick: this._actShare.bind(this),
          style: shareBtnStyle
        }),
        _react2.default.createElement('div', {
          className: 'broccoli-cmp-actend-feedback',
          onClick: this._actRule.bind(this),
          style: ruleBtnStyle
        }),
        _react2.default.createElement(_broccoliChangeLange2.default, langeConf)
      );
    }
  }]);

  return Index;
}(_react.Component);

Index.propTypes = {
  /**
  * @title 页面id，如：index、result
   */
  pg: _propTypes2.default.string,
  /**
  * @title 巴别塔定义的分享按钮key
   */
  shareScene: _propTypes2.default.string,
  /**
  * @title 规则页按钮的链接
   */
  linkRule: _propTypes2.default.string,
  /**
  * @title (首页)头部多语言功能相关设置
  */
  langeConf: _propTypes2.default.shape({
    /**
     * @title 页面展示的语言文案巴别塔key
     * @required
     * @description 必填
     */
    tabListKey: _propTypes2.default.string,
    /**
     * @title 背景色
     * @description 选填
     */
    bgColor: _propTypes2.default.string,
    /**
     * @title 选中背景色
     * @description 选填
     */
    selectBgColor: _propTypes2.default.string,
    /**
     * @title 按钮背景图
     * @description 选填
     */
    btnBgImg: _propTypes2.default.imgUrlString,
    /**
     * @title 按钮左边距离
     * @description 选填
     */
    left: _propTypes2.default.number,
    /**
     * @title 按钮上方距离
     * @description 选填
     */
    top: _propTypes2.default.number,
    /**
     * @title 按钮样式
     * @description 选填
     */
    btnStyle: _propTypes2.default.styleObject,
    /**
     * @title 展开列表样式
     * @description 选填
     */
    listStyle: _propTypes2.default.styleObject
  })
};
Index.defaultProps = {
  pg: 'index',
  shareScene: 'share_general',
  linkRule: './rule'
};
exports.default = Index;